"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setFocusedInboxConfigurationOperation_1 = require("owa-service/lib/operation/setFocusedInboxConfigurationOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
/**
 * Sets IsFocusedInboxCapable flag on server to indicate enable mailbox for focused inbox
 * @return the SetFocusedInboxConfigurationResponse
 */
function setIsFocusedInboxCapableService() {
    var request = {
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        IsFocusedInboxCapable: true,
    };
    return setFocusedInboxConfigurationOperation_1.default({
        request: request,
    }).then(function (response) {
        return response;
    });
}
exports.default = setIsFocusedInboxCapableService;
//# sourceMappingURL=setIsFocusedCapableService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-focused-option/lib/services/setIsFocusedCapableService.js
// module id = 5089
// module chunks = 2